import { render, staticRenderFns } from "./TopGoal.vue?vue&type=template&id=3323b8af&scoped=true&lang=pug&"
import script from "./TopGoal.vue?vue&type=script&lang=ts&"
export * from "./TopGoal.vue?vue&type=script&lang=ts&"
import style0 from "./TopGoal.vue?vue&type=style&index=0&id=3323b8af&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323b8af",
  null
  
)

export default component.exports